import React, { ReactElement } from 'react';
import styles from './CardGrid.module.scss';
export interface CardGridProps {
  children: ReactElement[];
}
const CardGrid = ({ children }: CardGridProps) => (
  <div className={styles['grid-container']}>
    <div className={styles['card-grid']}>{children}</div>
  </div>
);

export default CardGrid;
